import { render, staticRenderFns } from "./NotificationLinked.vue?vue&type=template&id=1a006b82&scoped=true&lang=pug&"
import script from "./NotificationLinked.vue?vue&type=script&lang=js&"
export * from "./NotificationLinked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a006b82",
  null
  
)

export default component.exports